/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, Fragment, useCallback, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { PDFLinkCard } from '../../../../_metronic/partials/content/cards/PDFLinkCard'
import { Link, useSearchParams } from 'react-router-dom'
import { useField, useFormik } from 'formik'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { has, omit } from 'lodash'
import clsx from 'clsx'
import { addArticle, getAllDegreeNames, getAllMajors, getAllPaperTypes, getPDFURL, loadFullPersonalPublication, updatePublicationStatus, UPLOAD_FILE_URL } from '../../auth/core/_api'
import { DegreeNameModel, FullPublicationModel, MajorModel, PaperTypeModel, useAuth, YearModel } from '../../auth'
import { getDoubleBlockFormik, getFormikSingleTextAreaBlock, getFormikSingleBlock, getTextAreaDoubleBlockFormik, getDoubleBlock, getSingleBlock, getHeader } from './util/ArticleUtil'
import {useDropzone} from 'react-dropzone'
import axios, { AxiosError } from 'axios'

const initialValues = {
    title_en: '',
    title_th: '',
    description: '',
    reference: '',
    contributor: '',
    advisor: '',
    abstract_en: '',
    abstract_th: '',
    public_year: '',
    degree_level: '',
    academic_year: '',
    keyword: '',
    journal_name: '',
    conference_name: '',
    major_id: '',
    degree_name_id: '',
    type_id: ''
}

function getStatusText(status:string){
    if(status == 'drafted'){
      return <span className="badge badge-square badge-info px-3"><span className='pe-1'>สถานะ:</span> <b>บันทึกร่าง</b></span>
    }
    else if(status == 'published'){
      return <span className="badge badge-square badge-success px-3"><span className='pe-1'>สถานะ:</span><b>เผยแพร่สาธารณะแล้ว</b></span>
    }
    else if(status == 'commented'){
      return <span className="badge badge-square badge-warning px-3"><span className='pe-1'>สถานะ:</span><b>แจ้งกลับรอการแก้ไข</b></span>
    }
    else if(status == 'submitted'){
      return <span className="badge badge-square badge-primary px-3"><span className='pe-1'>สถานะ:</span><b>รอตรวจสอบ</b></span>
    }
    else if(status == 'rejected'){
      return <span className="badge badge-square badge-danger px-3"><span className='pe-1'>สถานะ:</span><b>ปฏิเสธการเผยแพร่</b></span>
    }
    else{
      return status
    }
  }

const registrationSchema = Yup.object().shape({
    title_en: Yup.string()
        .min(3, 'น้อยสุด 3 อักษร')
        .max(1000, 'สูงสุด 1000 อักษร')
        .when('title_th', {
            is: (title_th: string | any[]) => !title_th || title_th.length === 0,
            then: Yup.string()
                .required('กรุณาระบุหัวข้อภาษาไทยและ/หรือภาษาอังกฤษ')
        }),
    title_th: Yup.string()
        .min(3, 'น้อยสุด 3 อักษร')
        .max(1000, 'สูงสุด 1000 อักษร')
        .when('title_en', {
            is: (title_en: string | any[]) => !title_en || title_en.length === 0,
            then: Yup.string()
                .required('กรุณาระบุหัวข้อภาษาไทยและ/หรือภาษาอังกฤษ')
        }),
    description: Yup.string()
        .max(2000, 'สูงสุด 2000 อักษร'),
    reference: Yup.string()
        .max(100, 'สูงสุด 100= อักษร'),
    contributor: Yup.string()
        .max(200, 'สูงสุด 200= อักษร')
        .required('กรุณาระบุผู้แต่ง'),
    advisor: Yup.string()
        .max(500, 'สูงสุด 500= อักษร'),
    public_year: Yup.string()
        .required('กรุณาเลือกปี'),
    degree_level: Yup.string()
        .required('กรุณาเลือกระดับการศึกษา'),
    academic_year: Yup.string()
        .required('กรุณาเลือกปีการศึกษา'),
    keyword: Yup.string()
        .max(500, 'สูงสุด 500= อักษร'),
    journal_name: Yup.string()
        .max(500, 'สูงสุด 500= อักษร'),
    conference_name: Yup.string()
        .max(500, 'สูงสุด 500= อักษร'),
}, [['title_en', 'title_th']]);

function getArticleHeaderType(key:string){
    if(key == '1'){
        return 'หัวข้อภาคนิพนธ์'
    }
    else if(key == '2' || key == '3'){
        return 'หัวข้อวิทยานิพนธ์'
    }
    else if(key == '4' || key == '5'){
        return 'ชื่อผลงานวิจัย'
    }
    return 'ชื่อผลงาน'
}

const PublicationAdd: React.FC = () => {
    const { currentUser, logout } = useAuth()
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [textFormatting, setTextFormatting] = useState<boolean>(false)
    const [loading, setLoading] = useState(false)
    const [articleTypes, setArticleTypes] = useState<PaperTypeModel[]>()
    const [selectedType, setSelectedType] = useState('')
    const [articleMajors, setArticleMajors] = useState<MajorModel[]>()
    const [articleDegreeNames, setArticleDegreeNames] = useState<DegreeNameModel[]>()
    const [publicStatus, setPublicStatus] = useState('')
    const [publicationID, setPublicationID] = useState<string | null>('')
    
    const [publicYears, setPublicYears] = useState<YearModel[]>()
    const [selectedPublicYear, setSelectedPublicYear] = useState('')
    const [selectedAcademicYear, setSelectedAcademicYear] = useState('')
    const [selectedDegree, setSelectedDegree] = useState('')
    const [selectedMajor, setSelectedMajor] = useState('')
    const [selectedDegreeName, setSelectedDegreeName] = useState('')
    const [uploadFile, setUploadFile] = useState<string>('');
    const [comment, setComment] = useState<string>('');
    const [rejectReason, setRejectReason] = useState<string>('');

    const curYear = (new Date()).getFullYear()
    var year_arr = new Array<YearModel>()

    for(var i=curYear; i>=1990; i--){
        year_arr.push({label: `${i}/${i+543}`, value: `${i}`})
    }    

    const onDrop = useCallback((acceptedFiles:any) => {
        handleFileInputChange(acceptedFiles[0]);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf']
        },
        multiple: false,
    })

    const submitArticle = async () => {
        if(publicationID){
            await updatePublicationStatus(publicationID, 'submitted', currentUser ? `${currentUser.id}`: '')
            setPublicStatus("submitted")
            Swal.fire('สำเร็จ!', 'ระบบได้ส่งให้เจ้าหน้าที่ตรวจสอบเรียบร้อย ท่านจะได้รับอีเมลแจ้งเตือนเมื่อการตรวจสอบเสร็จสิ้น', 'success')
        }
        else{
            Swal.fire({
                title: 'แจ้งเตือน!',
                text: 'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่ในภายหลัง',
                icon: 'warning'
            })
        }
    }

    const handlePublicationSubmit = () => {
        formik.validateForm().then((errors)=>{
            if(Object.keys(errors).length !== 0 || !uploadFile){
                Swal.fire({
                    title: 'แจ้งเตือน!',
                    text: 'กรุณาตรวจสอบความถูกต้อง',
                    icon: 'warning'
                })
            }
            else{
                Swal.fire({
                    title: 'ยืนยัน?',
                    text: 'คุณต้องการส่งให้เจ้าหน้าที่ตรวจสอบใช่หรือไม่',
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'ใช่ (ยืนยัน)',
                    cancelButtonText: `ไม่ใช่ (ยกเลิก)`
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        submitArticle()
                    }
                  })
            }
        })
    }

    const handleFileInputChange = (file:any) => {
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            Swal.fire({
                title: 'Uploading...',
                html: 'Please wait...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading(null)
                }
            });
        }
        reader.onloadend = () => {

            if(reader.result){
                axios.post(UPLOAD_FILE_URL, { data: reader.result}).then((response)=>{
                    setUploadFile(response.data.file_name)
                    Swal.close()
                })
            }
            else{
                alert('error')
                Swal.close()
            }
        }
    }
    
    //formik.setFieldValue("title_th", 'test')

    useEffect(() => {
        async function updatePaperType() {
            const types = await getAllPaperTypes()
            var type_arr = new Array<PaperTypeModel>()
            types.data.types.forEach((type: PaperTypeModel) => {
                type_arr.push(type)
            });
            setArticleTypes(type_arr)
        };

        async function updateMajor() {
            const majors = await getAllMajors()
            var major_arr = new Array<MajorModel>()
            majors.data.majors.forEach((major: MajorModel) => {
                major_arr.push(major)
            });
            setArticleMajors(major_arr)
        };

        async function updateDegreeName() {
            const degrees = await getAllDegreeNames()
            var degree_arr = new Array<DegreeNameModel>()
            degrees.data.majors.forEach((degree: DegreeNameModel) => {
                degree_arr.push(degree)
            });
            setArticleDegreeNames(degree_arr)
        };

        async function loadPublication(pid:string | null) {
            if(currentUser){
                const publication = await loadFullPersonalPublication(pid)
                const p:FullPublicationModel = publication.data.publication
                
                p.title_th && formik.setFieldValue("title_th", p.title_th)
                p.title_en && formik.setFieldValue("title_en", p.title_en)
                p.description && formik.setFieldValue("description", p.description)
                p.major_id && formik.setFieldValue("major_id", p.major_id)
                p.reference && formik.setFieldValue("reference", p.reference)
                p.contributor && formik.setFieldValue("contributor", p.contributor)
                p.advisor && formik.setFieldValue("advisor", p.advisor)
                p.abstract_en && formik.setFieldValue("abstract_en", p.abstract_en)
                p.abstract_th && formik.setFieldValue("abstract_th", p.abstract_th)
                p.public_year && formik.setFieldValue("public_year", p.public_year)
                p.degree_level && formik.setFieldValue("degree_level", p.degree_level)
                p.academic_year && formik.setFieldValue("academic_year", p.academic_year)
                p.keyword && formik.setFieldValue("keyword", p.keyword)
                p.type_id && formik.setFieldValue("type_id", p.type_id)
                p.journal_name && formik.setFieldValue("journal_name", p.journal_name)
                p.conference_name && formik.setFieldValue("conference_name", p.conference_name)
                p.degreename_id && formik.setFieldValue("degreename_id", p.degreename_id)
                p.pdf_file && formik.setFieldValue("pdf_file", p.pdf_file)

                if(p.pdf_file){
                    setUploadFile(p.pdf_file)
                }
                if(p.major_id){
                    setSelectedMajor(p.major_id)
                }
                if(p.status){
                    setPublicStatus(p.status)
                }
                if(p.type_id){
                    setSelectedType(p.type_id)
                }
                if(p.comment){
                    setComment(p.comment)
                }
                if(p.reject_reason){
                    setRejectReason(p.reject_reason)
                }
            }
        }

        if(searchParams && searchParams.get('pid')){
            //alert(searchParams.get('pid'))
            if(searchParams.get('pid') != null){
                loadPublication(searchParams.get('pid'))
                setPublicationID(searchParams.get('pid'))
            }
        }

        updatePaperType();
        updateMajor();
        updateDegreeName();
        setPublicYears(year_arr);
    }, []);

    const formik = useFormik({
        initialValues,
        validationSchema: registrationSchema,
        onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
            //setLoading(false)
            try {
                if(!uploadFile){
                    Swal.fire({
                        title: 'แจ้งเตือน!',
                        text: 'กรุณาอัพโหลดไฟล์ PDF',
                        icon: 'warning'
                    })
                }
                else{
                    var opt = (publicStatus)?'update':'insert'
                    const res: any = await addArticle(
                        values.title_th, values.title_en, values.description, values.reference, 
                        values.contributor, values.advisor, values.abstract_en, values.abstract_th,
                        values.public_year, values.degree_level, values.academic_year, values.keyword,
                        values.major_id, values.degree_name_id, values.journal_name, values.conference_name,
                        uploadFile, `${selectedType}`, publicStatus, currentUser ? currentUser.id: undefined, 
                        opt, publicationID?publicationID:'')
    
                    /*const { status: string } = await addArticle(
                        values.title_th, values.title_en, values.description, values.reference, 
                        values.contributor, values.advisor, values.abstract_en, values.abstract_th,
                        values.public_year, values.degree_level, values.academic_year, values.keyword,
                        values.major_id, values.degree_name_id)*/

                    Swal.fire({
                        title: 'Success!',
                        text: 'บันทึกข้อมูลเรียบร้อยแล้ว',
                        icon: 'success',
                        didClose: ()=>{
                            if(opt == "insert"){
                                const pid = res.data.pid
                                setPublicStatus("drafted")
                                setPublicationID(pid)
                            }
                        }
                    }).then(()=>{
                        //resetForm();
                    })
                }
                

                setLoading(false)

                
                
            } catch (e) {
                console.error('error: '+e)
                const err = e as AxiosError
                const error_data = err.response?.data
                const error_msg = error_data.msg ?? 'The input details is incorrect'

                Swal.fire({
                    title: 'เกิดข้อผิดพลาด!',
                    text: error_msg,
                    icon: 'warning'
                })

                setStatus(error_msg)
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    const publicYearProps = omit(formik.getFieldProps('public_year'), 'onChange');
    const academicYearProps = omit(formik.getFieldProps('academic_year'), 'onChange');

    return (
        <EnableSidebar>
            <form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                noValidate
                id='kt_login_signup_form'
                onSubmit={formik.handleSubmit}
            >
                {formik.status && (
                    <div className='mb-lg-15 alert alert-danger'>
                        <div className='alert-text font-weight-bold'>{formik.status}</div>
                    </div>
                )}

                <div className='d-flex flex-stack'>
                    <div>
                        {publicStatus && getStatusText(publicStatus)} {publicStatus=="commented" && <span className='fs-3 text-danger'>คำแนะนำ: {comment}</span>}
                    </div>
                    <div className='w-300px'>
                        <select
                            {...formik.getFieldProps('type_id')}
                            className='form-select'
                            data-control='select2'
                            data-placeholder='Select a product'
                            name='product'
                            onChange={e => {
                                formik.setFieldValue("type_id", e.target.value)
                                setSelectedType(e.target.value)
                            }}
                        >
                            {
                                articleTypes && articleTypes.map(({ id, type_name }) => (
                                    <option key={type_name} value={id}>
                                        {type_name}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                </div>

                <div className='mb-0'>
                    <div className=''>
                        <div className='d-flex align-items-center py-1'>
                            {uploadFile && <div className='symbol symbol-35px me-2'>
                                <PDFLinkCard icon='/media/svg/files/pdf.svg' title='ไฟล์ที่อัพโหลดแล้ว' url={(uploadFile)?getPDFURL(uploadFile):"#"} />
                            </div>}

                            <div className='w-100 upload'>
                                <div
                                    {...getRootProps()}
                                    className={`dropzone ${isDragActive ? "active" : null}`}
                                >
                                    <input {...getInputProps()} />
                                    {
                                        isDragActive ?
                                            <p>วางไฟล์ PDF ที่นี้ ...</p> :
                                            <p>ลากไฟล์ PDF มาวางหรือคลิ๊กเพื่อเลือกไฟล์</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <span>กรุณาอัพโหลดไฟล์ภาคนิพนธ์/งานวิจัย ในรูปแบบ pdf (ไฟล์รวม) ขนาดไฟล์ไม่เกิน 20 MB จำนวนไม่เกิน 1 ไฟล์ ข้าพเจ้าผู้เป็นเจ้าของผลงานภาคนิพนธ์/งานวิจัยฉบับนี้ ยอมรับให้คณะศิลปศาสตร์ สามารถเผยแพร่ผลงานในรูปแบบไฟล์อิเล็กทรอนิกส์ ในระบบคลังความรู้คณะศิลปศาสตร์ได้</span>

                    {/*getFormikSingleBlock('title (en)', formik.getFieldProps('title_en'), formik.touched.title_en, formik.errors.title_en)*/}
                    {/*getFormikSingleBlock('title (th)', formik.getFieldProps('title_th'), formik.touched.title_th, formik.errors.title_th)*/}

                    {getDoubleBlockFormik(
                        getArticleHeaderType(selectedType), 
                        formik.getFieldProps('title_th'), 
                        formik.touched.title_th, 
                        formik.errors.title_th, 
                        formik.getFieldProps('title_en'), 
                        formik.touched.title_en, 
                        formik.errors.title_en,
                        true
                    )}

                    {getFormikSingleTextAreaBlock(
                        'รายละเอียด',
                        formik.getFieldProps('description'), 
                        formik.touched.description, 
                        formik.errors.description,
                        false
                    )}

                    {getFormikSingleBlock(
                        'หมายเลขอ้างอิง',
                        formik.getFieldProps('reference'), 
                        formik.touched.reference, 
                        formik.errors.reference,
                        false
                    )}

                    {getFormikSingleBlock(
                        'ชื่อผู้แต่ง',
                        formik.getFieldProps('contributor'), 
                        formik.touched.contributor, 
                        formik.errors.contributor,
                        true
                    )}

                    {getFormikSingleBlock(
                        'อาจารย์ที่ปรึกษา',
                        formik.getFieldProps('advisor'), 
                        formik.touched.advisor, 
                        formik.errors.advisor,
                        false
                    )}

                    {getTextAreaDoubleBlockFormik(
                        'บทคัดย่อ', 
                        formik.getFieldProps('abstract_th'), 
                        formik.touched.abstract_th, 
                        formik.errors.abstract_th, 
                        formik.getFieldProps('abstract_en'), 
                        formik.touched.abstract_en, 
                        formik.errors.abstract_en,
                        false
                    )}

                    {selectedType == "journal" && getFormikSingleBlock(
                        'ชื่อวารสารที่ตีพิมพ์',
                        formik.getFieldProps('journal_name'), 
                        formik.touched.journal_name, 
                        formik.errors.journal_name,
                        false
                    )}

                    {selectedType == "conference" && getFormikSingleBlock(
                        'ชื่องานประชุมทางวิชาการ',
                        formik.getFieldProps('conference_name'), 
                        formik.touched.conference_name, 
                        formik.errors.conference_name,
                        false
                    )}

                    <div className='fv-row mb-7'>
                        {getHeader('ปีที่เผยแพร่', true)}
                        <select
                            data-control='select2'
                            {...publicYearProps /* {...formik.getFieldProps('public_year')} */}
                            onChange={e => {
                                setSelectedPublicYear(e.target.value)
                                formik.setFieldValue("public_year", e.target.value)
                            }}
                            className={clsx(
                                'form-select',
                                { 'is-invalid': formik.touched.public_year && formik.errors.public_year },
                                {
                                    'is-valid': formik.touched.public_year && !formik.errors.public_year,
                                }
                            )}
                        >
                            <option value={''}>--- เลือกปี ---</option>
                            {
                                publicYears && publicYears.map(({ label, value }) => (
                                    <option key={label} value={value}>
                                        {label}
                                    </option>
                                ))
                            }
                        </select>
                        {formik.touched.public_year && formik.errors.public_year && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.public_year}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='fv-row mb-7'>
                        {getHeader('ระดับการศึกษา', true)}
                        <select
                            data-control='select2'
                            {...formik.getFieldProps('degree_level')}
                            onChange={e => {
                                setSelectedDegree(e.target.value)
                                formik.setFieldValue("degree_level", e.target.value)
                            }}
                            className={clsx(
                                'form-select',
                                { 'is-invalid': formik.touched.degree_level && formik.errors.degree_level },
                                {
                                    'is-valid': formik.touched.degree_level && !formik.errors.degree_level,
                                }
                            )}
                        >
                            <option value={''}>--- เลือกระดับการศึกษา ---</option>
                            <option key="undefined" value="undefined">ไม่ระบุ/ผลงานพนักงาน</option>
                            <option key="bachelor" value="bachelor">ปริญญาตรี</option>
                            <option key="master" value="master">ปริญญาโท</option>
                            <option key="doctor" value="doctor">ปริญญาเอก</option>
                        </select>
                        {formik.touched.degree_level && formik.errors.degree_level && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.degree_level}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='fv-row mb-7'>
                        {getHeader('ปีการศึกษา', true)}
                        <select
                            data-control='select2'
                            {...academicYearProps}
                            onChange={e => {
                                setSelectedAcademicYear(e.target.value)
                                formik.setFieldValue("academic_year", e.target.value)
                            }}
                            className={clsx(
                                'form-select',
                                { 'is-invalid': formik.touched.academic_year && formik.errors.academic_year },
                                {
                                    'is-valid': formik.touched.academic_year && !formik.errors.academic_year,
                                }
                            )}
                        >
                            <option value={''}>--- เลือกปี ---</option>
                            {
                                publicYears && publicYears.map(({ label, value }) => (
                                    <option key={label} value={value}>
                                        {label}
                                    </option>
                                ))
                            }
                        </select>
                        {formik.touched.public_year && formik.errors.public_year && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.public_year}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {getFormikSingleTextAreaBlock(
                        'คำสำคัญ',
                        formik.getFieldProps('keyword'), 
                        formik.touched.keyword, 
                        formik.errors.keyword,
                        false
                    )}

                    <div className='fv-row mb-7'>
                        {getHeader('สาขาวิชา', false)}
                        <select
                            {...formik.getFieldProps('major_id')}
                            className='form-select'
                            data-control='select2'
                            data-placeholder='Select a product'
                            name='product'
                            onChange={e => {
                                setSelectedMajor(e.target.value)
                                formik.setFieldValue("major_id", e.target.value)
                            }}
                        >
                            <option value={''}>--- เลือกสาขา ---</option>
                            {
                                articleMajors && articleMajors.map(({ id, major_name }) => (
                                    <option key={major_name} value={id}>
                                        {major_name}
                                    </option>
                                ))
                            }
                        </select>
                    </div>

                    <div className='fv-row mb-7'>
                        {getHeader('ชื่อปริญญา', false)}
                        <select
                            {...formik.getFieldProps('degreename_id')}
                            className='form-select'
                            data-control='select2'
                            data-placeholder='Select a product'
                            name='product'
                            onChange={e => {
                                setSelectedDegreeName(e.target.value)
                                formik.setFieldValue("degree_name_id", e.target.value)
                            }}
                        >
                            <option value={''}>--- เลือกชื่อปริญญา ---</option>
                            {
                                articleDegreeNames && articleDegreeNames.map(({ id, degree_name }) => (
                                    <option key={degree_name} value={id}>
                                        {degree_name}
                                    </option>
                                ))
                            }
                        </select>
                    </div>

                    {/*{articles.map((a, i) => {
                        return (
                            <Fragment key={`article_${i}`}>
                                {(a.en_text) ? getDoubleBlock(a.title, a.th_text, a.en_text) : getSingleBlock(a.title, a.th_text)}
                            </Fragment>
                        )
                    })} */}

                </div>

                <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>
                <button
                    type='submit'
                    id='submit_form'
                    className='btn btn-primary me-2'
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    {!loading && <span className='indicator-label'>{(publicStatus=="")?"บันทึกร่าง":"บันทึก"}</span>}
                    {loading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
                {(publicStatus == 'drafted' || publicStatus == 'commented') && <button onClick={handlePublicationSubmit} type='button' className="btn btn-success">ส่งให้เจ้าหน้าที่ตรวจสอบ</button>}
            </form>
        </EnableSidebar>
    )
}

export { PublicationAdd }
